

(function cardProduct () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "card-product";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
    })

    })()